import useEvent from "react-use-event-hook";
import { useRecoilState, useSetRecoilState } from "recoil";

import {
  bulkOperationsDrawerAF,
  bulkSelectedControlsAtomFamily,
  bulkUpdateFormDrawerAF,
  Log,
  RydeUiUnit,
} from "@ryde/shared";

export const useCrudEditBulk = (entity: RydeUiUnit) => {
  const [selectedFields, setIsSelected] = useRecoilState(
    bulkSelectedControlsAtomFamily(entity),
  );
  const setBulkUpdateFormDrawerOpened = useSetRecoilState(
    bulkUpdateFormDrawerAF(entity),
  );
  const setBulkOperationsDrawerState = useSetRecoilState(
    bulkOperationsDrawerAF(entity),
  );

  const openBulkEditForm = useEvent((): void => {
    setBulkOperationsDrawerState(false);
    setBulkUpdateFormDrawerOpened(true);

    if (selectedFields?.length) {
      setIsSelected([]);
    }

    Log.debug(`Open bulk edit form , entity: ${entity}`);
  });

  const handleBulkCrudCancel = useEvent((): void => {
    setBulkUpdateFormDrawerOpened(false);
    Log.debug(`Cancel on bulk edit form, entity: ${entity}`);
  });

  const handleBulkCrudOk = useEvent((): void => {
    setBulkUpdateFormDrawerOpened(false);
    Log.debug(`OK on bulk edit form, entity: ${entity}`);
  });

  return { openBulkEditForm, handleBulkCrudCancel, handleBulkCrudOk };
};
